import {AuthLayoutStyle} from "./auth.layout.style";
import {Outlet, useLocation} from "react-router";
import React from "react";
import {useAuth} from "../../providers/authentication.provider";
import {Navigate, useSearchParams} from "react-router-dom";
import {PageLoader} from "../../components/loaders";

export const AuthLayout = () => {
    const {isAuthenticated, isAppInitialized, isGuestUser} = useAuth()
    const [searchParams] = useSearchParams();
    const location = useLocation()

    if (!isAppInitialized) return <PageLoader/>

    if(location.pathname.startsWith("/guest-sign-in") && !isAuthenticated){
        return <Outlet />
    }

    if (!isAuthenticated) return <AuthLayoutStyle>
        <div className="first_content"></div>
        <Outlet/>
    </AuthLayoutStyle>

    return <Navigate to={`${searchParams.get("redirect_to") || "/"}`}/>
}